// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import '@styles/webdesktop/stylesheets/comboboxDropdownItem.scss';
import React from 'react';
import { Style, StyleContext, StyleState } from '../../../Style';
import { Size } from '@front/sharedcomponents/Variables';
export const ComboboxDropdownItemDecorator = (_a) => {
    var { isSelected = false, children, onClick, size = Size.Medium } = _a, restProps = __rest(_a, ["isSelected", "children", "onClick", "size"]);
    const dropdownItemClassNames = [
        'combobox-dropdown-item',
        size,
        Style.Secondary,
        StyleContext.ListItem,
        isSelected ? StyleState.Checked : ''
    ];
    const dropdownItemClassName = dropdownItemClassNames.filter(Boolean).join(' ');
    return (React.createElement("div", Object.assign({ className: dropdownItemClassName, role: "option", tabIndex: 0, "aria-selected": isSelected, onClick: onClick, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
            }
        } }, restProps), children));
};
